import { TableCellTypes } from '@carboledger/ui';
import {
  makeUnitTypeCell,
  makeUnitScopedCell,
  makeDiscrepanciesCell,
  makeRemoveCell,
} from '@/components/common';
import { buildRowUnitOptions } from './orderUnits';

// Columns for the Select outgoing shipment modal (radio pick) and its confirmed, single-row inline table (Remove) — everything but the leading column is shared between the two.

const renderUnitTypeCell = makeUnitTypeCell((t, row) => buildRowUnitOptions(t, row.byUnit));
const renderAssignedQuantity = makeUnitScopedCell('assignedQuantity');
const renderShipmentQuantity = makeUnitScopedCell('shipmentQuantity');
const renderRemainingToAllocate = makeUnitScopedCell('remainingToAllocateQuantity');
const renderUnassignedQuantity = makeUnitScopedCell('unassignedQuantity');

const textColumn = (id, header, width = 180) => ({ id, header, type: TableCellTypes.text, width });

/** @param onOpenDiscrepancy (row) => void — opens the row's Discrepancies modal */
const buildSharedColumns = (t, { unitHeaderSelect, onOpenDiscrepancy }) => [
  textColumn('shipmentId', t('FIELD_SHIPMENT_ID'), 160),
  textColumn('totalOrdersLinked', t('FIELD_TOTAL_ORDER_LINKED'), 160),
  {
    id: 'unitType',
    header: t('FIELD_UNIT_TYPE', { unit: unitHeaderSelect.value }),
    type: TableCellTypes.custom,
    width: 220,
    cell: renderUnitTypeCell,
    headerSelect: unitHeaderSelect,
  },
  {
    id: 'assignedQuantity',
    header: t('FIELD_ASSIGNED_QUANTITY_ORDER'),
    type: TableCellTypes.custom,
    width: 220,
    cell: renderAssignedQuantity,
  },
  {
    id: 'shipmentQuantity',
    header: t('FIELD_SHIPPED_QUANTITY'),
    type: TableCellTypes.custom,
    width: 180,
    cell: renderShipmentQuantity,
  },
  {
    id: 'remainingToAllocateQuantity',
    header: t('ORDERS_COL_REMAINING_TO_ALLOCATE'),
    type: TableCellTypes.custom,
    width: 200,
    cell: renderRemainingToAllocate,
  },
  {
    id: 'unassignedQuantity',
    header: t('FIELD_UNASSIGNED_QUANTITY'),
    type: TableCellTypes.custom,
    width: 200,
    cell: renderUnassignedQuantity,
  },
  { ...textColumn('dateOfDispatch', t('FIELD_DATE_OF_DISPATCH'), 150), type: TableCellTypes.date },
  {
    id: 'discrepancies',
    header: t('FIELD_DISCREPANCIES'),
    type: TableCellTypes.custom,
    width: 180,
    cell: makeDiscrepanciesCell(onOpenDiscrepancy),
  },
];

// The picker's data columns; PickFromTableModal prepends the radio itself.
export const buildSelectOutgoingShipmentColumns = buildSharedColumns;

/**
 * @param unitHeaderSelect   the header's "switch every row" unit control
 * @param onOpenDiscrepancy  (row) => void — opens the row's Discrepancies modal
 * @param onRemove           () => void — clears the confirmed pick
 */
// The picked row: read-only, Assigned quantity (This order) included — dispatch derives it from the certified total.
export const buildSelectedOutgoingShipmentColumns = (
  t,
  { unitHeaderSelect, onOpenDiscrepancy, onRemove },
) => [
  ...buildSharedColumns(t, { unitHeaderSelect, onOpenDiscrepancy }),
  {
    id: '__remove__',
    header: t('FIELD_ACTION'),
    type: TableCellTypes.custom,
    width: 120,
    resizable: false,
    cell: makeRemoveCell(onRemove),
  },
];
